<script setup>
import { useScreen } from '@/composables/useScreen'
import { VueperSlides, VueperSlide } from 'vueperslides'

const { isMobileView } = useScreen()
const carouselKey = ref(0)

const slides = [
  {
    label: 'lawyer_search_with_ai',
    imageName: 'freeGeneralAdvice.jpg',
    description: 'lawyer_search_with_ai_description'
  },
  {
    label: 'introducery_meeting_to_clarify',
    imageName: 'createRequest.jpg',
    description: 'introducery_meeting_to_clarify_description'
  },
  {
    label: 'register_with_the_desired_lawyer',
    imageName: 'selectLawyerFromList.jpg',
    description: 'register_with_the_desired_lawyer_description'
  }
]

// Tracking change to mobile view, to rerender component. Otherwise 1 card becomes bigger cause of elementPlus "card" type carousel.
onMounted(() => {
  watch(isMobileView, (newValue) => {
    if (newValue) {
      carouselKey.value += 1
    }
  })
})

// Calculating slides alignmend depending on active slide. Active is in center. Non active must be aligned to the very left and right.
const slideClasses = ref(['justify-center', 'justify-end', ''])
function slideChanged(activeSlide) {
  slideClasses.value = slideClasses.value.map((_, index) => {
    if (index === activeSlide) {
      return 'justify-center'
    } else if ((index + 1) % 3 === activeSlide) {
      return ''
    }
    return 'justify-end'
  })
}

const slidesCount = 3
const arrowShift = computed(() => 45 + (slidesCount * 34 / 2))
</script>
<template>
  <div v-if="isMobileView">
    <vueper-slides
      class="no-shadow"
      :visible-slides="1"
      :gap="5"
      fixed-height="550px"
      :autoplay="true"
      :touchable="true"
      :dragging-distance="10"
    >
      <template #bullet="{ active }">
        <div class="relative w-[25px] h-[4px] -mx-[6px] top-[10px] bg-darkBlue" :class="{'opacity-55' : !active}" />
      </template>
      <template #arrow-left>
        <div class="relative top-[259px]" :style="{left: `-${arrowShift}px`}">
          <IconArrowFullLeft class="text-darkBlue" />
        </div>
      </template>
      <template #arrow-right>
        <div class="relative top-[259px]" :style="{right: `-${arrowShift}px`}">
          <IconArrowFullRight class="text-darkBlue" />
        </div>
      </template>
      <vueper-slide v-for="(slide, index) in slides" :key="index">
        <template #content>
          <div class="font-redhat font-medium text-white w-full bg-lightBlue rounded-[40px] w-[330px] h-[484px]">
            <div class="mx-6 pt-6 leading-tight text-2xlg text-center">
              {{ $t(slide.label) }}
            </div>
            <div class="mx-6 mt-8 flex justify-center">
              <img :src="`/images/WhatWeOffer/${slide.imageName}`" class="max-h-[250px] rounded-[20px]">
            </div>
            <div class="w-[65px] border-b-2 border-white-500 ml-6 mt-10" />
            <div class="mx-6 mt-6 leading-normal text-md">
              {{ $t(slide.description) }}
            </div>
          </div>
        </template>
      </vueper-slide>
    </vueper-slides>
  </div>

  <div v-else>
    <el-carousel
      :key="carouselKey"
      :interval="4000"
      type="card"
      height="500px"
      arrow="never"
      indicator-position="none"
      @change="slideChanged"
    >
      <el-carousel-item v-for="(slide, index) in slides" :key="index">
        <div class="flex" :class="slideClasses[index]">
          <div class="font-redhat font-medium text-white w-full bg-lightBlue rounded-[40px] lg:w-2/3 h-[448px] min-w-[420px] h-[494px]">
            <div class="mx-6 pt-6 leading-tight text-2xlg text-30">
              {{ $t(slide.label) }}
            </div>
            <div class="mx-6 mt-8">
              <img :src="`/images/WhatWeOffer/${slide.imageName}`" class="rounded-[20px]">
            </div>
            <div class="w-[65px] border-b-2 border-white-500 ml-6 mt-10" />
            <div class="mx-6 mt-6 leading-normal text-md">
              {{ $t(slide.description) }}
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<style scoped>
:deep(.vueperslides__arrow) {
  opacity: 1;
}

:deep(.vueperslides__arrow--prev) {
  left: 50%;
}

:deep(.vueperslides__arrow--next) {
  right: 50%;
}
</style>